import type { CompactionStreamStatus, StreamStatusEntry } from '../types/chat';
import { getCompactionStreamStatusLabel } from '../utils/conversation-compaction';
import { MessageWorkingIndicator } from './MessageLoading';
import { StreamStatusTimeline } from './StreamStatusTimeline';

interface AssistantWorkingStatusProps {
  entries?: StreamStatusEntry[];
  compactionStreamStatus?: CompactionStreamStatus;
}

export function AssistantWorkingStatus({
  entries = [],
  compactionStreamStatus,
}: Readonly<AssistantWorkingStatusProps>) {
  const compactionLabel = compactionStreamStatus
    ? getCompactionStreamStatusLabel(compactionStreamStatus)
    : undefined;
  const hideTimeline = compactionStreamStatus === 'started';

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-2 py-0.5">
      <MessageWorkingIndicator label={compactionLabel} />
      {!hideTimeline && <StreamStatusTimeline entries={entries} />}
    </div>
  );
}
